/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';

import { BlendBridge } from 'blb-types/blendBridge';

export type MeContext = BlendBridge.API.User | null;

export const MeContext = React.createContext<MeContext>(null);
